import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'modifyStars'
})
export class ModifyStarsPipe implements PipeTransform {
  transform(val: string): string {
    return val
      .replace('(3*)', '')
      .replace('(4*)', '')
      .replace('(5*)', '')
      .replace('(6*)', '')
      .replace('(7*)', '');
  }
}
